export default {
    getGroups: { method: 'get', url: 'groups' },
    postGroups: { method: 'post', url: 'groups' },
    putGroups: { method: 'put', url: 'groups/{id}' },
    deleteGroups: { method: 'delete', url: 'groups/{id}' },
}
